/**
 * Честный вход на Олимп, пока нет доказанного адреса матча.
 *
 * `undefined` в path — битая ссылка (`broken_link`). Раздел `/live` не
 * событие: тестер ищет строку, как на Positive. Id события — из payload.
 */

import { opponentOf } from './positiveDoor';

export { opponentOf };

export function olimpFindLine(
  name: string,
  opponent: string,
  eid?: string | null,
): string {
  const pair = opponent && opponent !== name ? `${name} / ${opponent}` : name;
  const id = eid ? ` · id ${eid}` : '';
  return `лайв Олимпа — найди ${pair}${id}`;
}
